import { defineAsyncComponent } from 'vue'
export default {
  private: defineAsyncComponent(() => import("C:/repositories/optilink-parent/web-portal-frontend/layouts/private.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("C:/repositories/optilink-parent/web-portal-frontend/layouts/public.vue").then(m => m.default || m))
}